import funnelsHeader from '../../components/dashboard/paywall/sales-activated-trial/page/images/funnels-header.png';
import funnelsSection1 from '../../components/dashboard/paywall/sales-activated-trial/page/images/funnels-section1.png';
import funnelsSection2 from '../../components/dashboard/paywall/sales-activated-trial/page/images/funnels-section2.png';
import funnelsSection3 from '../../components/dashboard/paywall/sales-activated-trial/page/images/funnels-section3.png';
import type { PageblockData } from '../pageblockTypes';

export const PAGEBLOCK_DATA_FUNNEL_MAPS: PageblockData = {
  headerData: {
    headerText: 'Create new business processes with funnel editor',
    subHeaderText:
      'Design, optimize, and manage your business workflows with an intuitive and collaborative visual funnel editor.',
    imgSrc: funnelsHeader,
    imgAlt: 'Funnels header img',
    name: 'Funnels',
  },
  pageTitle: `Optimize and collaborate on your customer journey with Sweep's visual funnel editor`,
  section1: {
    imgSrc: funnelsSection1,
    imgAlt: 'Funnels section img',
    title: 'Full visualization of your customer journey',
    content:
      'Gain a comprehensive visual representation of your entire customer journey, allowing for better analysis and optimization of each stage.',
  },
  section2: {
    imgSrc: funnelsSection2,
    imgAlt: 'Funnels section 2 img',
    title: 'Business context into automations and validations',
    content:
      'Incorporate business context seamlessly into your automations and validations, ensuring that your processes align with organizational objectives.',
  },
  section3: {
    imgSrc: funnelsSection3,
    imgAlt: 'Funnels section 3 img',
    title: 'Collaborate with teammates',
    content:
      'Work collaboratively with your team in real-time within the Funnel Editor, enhancing efficiency and ensuring alignment across departments.',
  },
};
